import { apiGetReportTemplate, companyMrtUrl, PrintType, Report } from '@/api/util';
import { apiSelectPurchasePrint } from '@/api/purchase/purchase';
import store from '@/store';

/**
 * Purchase Order Print
 *
 * 수정일: 2024-07-04
 *
 * 변경 사항:
 * - 기존 Purchase Detail의 Purchase 객체를 참조하는 방식에서 서버 데이터를 참조하는 방식으로 수정
 *
 * @param {string} po_no - 주문 번호
 * @param {boolean} isRemaining - 남은 수량만 표시할지 여부
 * @param user - 사용자 객체
 * @returns {Promise<void>}
 */
export async function generateDefaultCompanyPurchaseOrderPrint(po_no, isRemaining, user) {
	const width = ['newjigu'].includes(user.company_id) ? 70 : 0;
	const { data } = await apiSelectPurchasePrint(po_no);
	console.log(data);
	if (isRemaining) {
		data.purchaseItemList = data.purchaseItemList.filter(el => el.remain_quantity);
	}

	data.isRemaining = isRemaining;

	let reportTemplate = await apiGetReportTemplate('PurchaseOrderDetail', companyMrtUrl('PurchaseOrderDetail'));
	const report = new Report(reportTemplate, data, 'PurchaseOrderDetail', PrintType.Normal, false, false, null, width);
	store.commit('setReport', report);
}
